import React, { useState } from "react";
import { Input, Form, Button, Select, Row, Col } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { CharacterVerify } from "../../../Utility/RegExp";

const { Option } = Select;

interface createUserProps {
  deviceGroups: any;
  CreateUserform: any;
  createUsers: any;
}

export const CreateUserModal = React.memo(({ deviceGroups, CreateUserform, createUsers }: createUserProps) => {
  const { t } = useTranslation();
  const { level, gid } = useAppSelector((state) => state.global);
  const [userLevel, setUserLevel] = useState<any>([]);

  //admin create user只能帶到自身的group
  const group_checker = (level: string, gid: string[]) => {
    if (!deviceGroups) {
      return;
    }

    let checkedDeviceGroup = deviceGroups.group_list;

    if (level === "admin" && gid.length) {
      checkedDeviceGroup = checkedDeviceGroup.filter((item: any) => gid.includes(item.gid));
    }

    return checkedDeviceGroup.map((item: any, index: number) => (
      <Option key={index} value={item.gid}>
        {" "}
        {item.gid}
      </Option>
    ));
  };

  return (
    <Form form={CreateUserform} onFinish={createUsers} layout="vertical">
      <div className="formwrap">
        <Form.List name="users">
          {(fields, { add, remove }) => {
            return (
              <div>
                {fields.map((field, index) => (
                  <Row gutter={24} justify="start" key={field.key} style={{ width: "100%" }}>
                    <Col xs={24} sm={24} md={24} lg={12} xl={7}>
                      <Form.Item
                        {...field}
                        name={[field.name, "name"]}
                        // fieldKey={[field.fieldKey, "name"]}
                        rules={[
                          {
                            type: "email",
                            required: true,
                            message: "Invalid email",
                          },
                          CharacterVerify,
                        ]}
                        label={t("ISMS.name")}
                      >
                        <Input maxLength={30} placeholder="Name@xxx.com" autoComplete="new-password" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={7}>
                      <Form.Item
                        {...field}
                        name={[field.name, "password"]}
                        label={t("ISMS.password")}
                        // fieldKey={[field.fieldKey, "password"]}
                        rules={[
                          {
                            required: true,
                            message: "Missing password",
                          },
                          CharacterVerify,
                        ]}
                      >
                        <Input.Password maxLength={30} placeholder={t("ISMS.Password")} autoComplete="new-password" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={3}>
                      <Form.Item
                        {...field}
                        name={[field.name, "level"]}
                        rules={[
                          {
                            required: true,
                            message: "Missing level",
                          },
                        ]}
                        label={t("ISMS.level")}
                      >
                        <Select
                          placeholder={t("ISMS.Select")}
                          onChange={(value) => setUserLevel({ ...userLevel, [field.key]: value })}
                        >
                          {level === "super_super" && <Option value="super">Super</Option>}
                          {(level === "super_super" || level === "super") && <Option value="admin">Admin</Option>}
                          <Option value="get">Get</Option>
                          <Option value="set">Set</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={4}>
                      <Form.Item
                        {...field}
                        name={[field.name, "gid"]}
                        initialValue={[]}
                        label={t("ISMS.Group(optional)")}
                        rules={[
                          {
                            required: (level === "admin" && gid.length) as boolean,
                            message: "Missing level",
                          },
                        ]}
                      >
                        <Select
                          maxTagCount={"responsive"}
                          mode={"multiple"}
                          placeholder={t("ISMS.DefaultAll")}
                          disabled={userLevel[field.key] === "super"}
                        >
                          {group_checker(level, gid)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={2} className="mb-2">
                      <Button
                        type="text"
                        ghost
                        danger
                        block
                        icon={<MinusCircleOutlined />}
                        onClick={() => {
                          remove(field.name);
                        }}
                      ></Button>
                    </Col>
                  </Row>
                ))}

                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => {
                      add();
                    }}
                    block
                  >
                    <PlusOutlined /> {t("ISMS.AddUser")}
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </div>
    </Form>
  );
});

export default CreateUserModal;
